// src/api/newsApi.ts

export type NewsApiResponse = {
  data: any[];
  meta?: any;
};

/**
 * GET news list
 * /{lang}/news-articles?page=1
 */
// src/api/newsApi.ts

/**
 * GET news list
 * /{lang}/news-articles?page=1
 */
export const getNewsApi = async (
  lang: "id" | "en",
  page = 1
) => {
  const res = await fetch(
    `https://admin-talentlink.digiline.id/api/${lang}/news-articles?page=${page}`
  );

  if (!res.ok) {
    throw new Error("Failed to fetch news");
  }

  return res.json(); // { articles: {...} }
};

/**
 * GET news detail
 * /{lang}/news-articles/{slug}
 */
export const getNewsDetailApi = async (
  lang: "id" | "en",
  slug: string
) => {
  const res = await fetch(
    `https://admin-talentlink.digiline.id/api/${lang}/news-articles/${slug}`
  );

  if (!res.ok) {
    throw new Error("Failed to fetch news detail");
  }

  return res.json(); // { article: {...} }
};
